import { useEffect } from 'react';
import { FieldPath, FieldValues, UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ApiError } from '../openapi';

export function useFormError<TFieldValues extends FieldValues = FieldValues>(
  form: UseFormReturn<TFieldValues>,
  fieldPath: FieldPath<TFieldValues>,
  error: ApiError | null | undefined,
) {
  const { t } = useTranslation();
  useEffect(() => {
    if (error) {
      form.setError(fieldPath, {
        type: 'manual',
        message: t([`${fieldPath}.${error.name}`, error.message], error.params),
      });
    } else {
      form.clearErrors(fieldPath);
    }

    return () => {
      form.clearErrors(fieldPath);
    };
  });
}
